/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerMasterApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  addCustomer(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'customerMaster/saveCustomer',
      Payload
    );
  }

  updateCustomer(payload): Observable<any> {
    return this.http.post(
      this.APIService + 'customerMaster/saveCustomer',
      payload
    );
  }

  getAllCustomer(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'customerMaster/getCustomers?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  getCustomerById(id): Observable<any> {
    return this.http.get(
      this.APIService + 'customerMaster/getCustomerById?id=' + id
    );
  }

  deleteCustomer(custId): Observable<any> {
    return this.http.delete(
      `${this.APIService}customerMaster/deleteCustomer?id=${custId}`
    );
  }
}
